<template>
  <li :class="accordionCssClasses">
    <div class="nav-header" @click="toggleAccordion()">
      <h3 class="facet-group-title">
        {{ groupName }}
      </h3>
      <i class="glyphicon glyphicon-chevron-down accordion-icon" />
      <div style="clear: both" />
    </div>
    <div class="accordion-body">
      <ul class="nav nav-list facet-list">
        <individual-facet
          v-for="facet in facets"
          :key="facet.id"
          :facet="facet"
          :is-selected="!!selectedFilters[facet.displayName]"
          @toggle-filter="onToggleFilter"
        />
      </ul>
    </div>
  </li>
</template>

<script>
  import Facet from './facet'

  export default {
    components: {
      'individual-facet': Facet
    },
    props: {
      groupName: { required: true, type: String },
      facets: { required: true, type: Array },
      selectedFilters: { required: true, type: Object }
    },
    data() {
      return {
        accordionOpen: true
      };
    },
    computed: {
      accordionCssClasses() {
        return this.accordionOpen ? 'nav-item' : 'nav-item accordion-clicked';
      }
    },
    methods: {
      toggleAccordion() {
        this.accordionOpen = !this.accordionOpen;
      },
      onToggleFilter(payload) {
        this.$emit('toggle-filter', payload);
      }
    }
  };
</script>
